import type { TargetFormat } from "../../domain/subscription-converter.ts";

export type BuildProviderEndpointInput = {
  origin: string;
  subscriptionUrl: string;
  target: TargetFormat;
};

export function buildProviderEndpoint({
  origin,
  subscriptionUrl,
  target,
}: BuildProviderEndpointInput): string {
  const endpoint = new URL("/api/convert", origin);
  endpoint.searchParams.set("url", subscriptionUrl);
  endpoint.searchParams.set("target", target);
  return endpoint.toString();
}

export function providerKeyFromUrl(subscriptionUrl: string): string {
  try {
    const hostname = new URL(subscriptionUrl).hostname;
    return sanitizeProviderKey(hostname || "provider_1");
  } catch {
    return "provider_1";
  }
}

export function buildClashSnippet(providerKey: string, providerUrl: string): string {
  return `proxy-groups:\n  - name: Proxy\n    type: select\n    use:\n      - ${providerKey}\n    proxies:\n      - DIRECT\n\nproxy-providers:\n  ${providerKey}:\n    type: http\n    url: "${providerUrl}"\n    interval: 3600\n    path: ./providers/${providerKey}.yaml\n    health-check:\n      enable: true\n      interval: 600\n      url: http://www.gstatic.com/generate_204\n`;
}

export function buildSurgeSnippet(providerKey: string, providerUrl: string): string {
  return `[Proxy Group]\n${providerKey} = select, policy-path=${providerUrl}, update-interval=3600\n`;
}

function sanitizeProviderKey(value: string): string {
  const sanitized = value.toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
  return sanitized || "provider_1";
}
